import {
  AuthResetPasswordOutput,
  AuthResetPasswordInput,
  AuthConfirmResetPasswordInput,
  AuthSession,
  AuthPasskey,
  FetchAuthSessionOptions,
} from '@wiwodesk/gs-identity';
import type { BackofficeSession, BackofficeUser } from '@wiwodesk/bc-backoffice';
import type { PrincipalSessionDto } from '@wiwodesk/gs-tenancy';
import { createSafeContext } from '@/utils/createSafeContext';
import { AuthSignInInput, AuthSignInOutput, AuthConfirmSignInInput } from '@wiwodesk/gs-identity';

export type AuthStatus = 'unknown' | 'authenticated' | 'ending' | 'unauthenticated';
export type SessionEndReason = 'logout' | 'expired';

export interface AuthContextType {
  authStatus: AuthStatus;
  isLoading: boolean;
  isInitialized: boolean;
  errorMessage: string | null;
  user: BackofficeUser | null;
  backofficeSession: BackofficeSession | null;
  tenancy: PrincipalSessionDto | null;
  needsOnboarding: boolean;
  signin: (input: AuthSignInInput) => Promise<AuthSignInOutput>;
  signout: () => Promise<void>;
  confirmSignIn: (input: AuthConfirmSignInInput) => Promise<AuthSignInOutput>;
  resetPassword: (input: AuthResetPasswordInput) => Promise<AuthResetPasswordOutput>;
  confirmResetPassword: (input: AuthConfirmResetPasswordInput) => Promise<void>;
  fetchAuthSession: (options?: FetchAuthSessionOptions) => Promise<AuthSession>;
  reloadBackofficeSession: () => Promise<void>;
  registerPasskey: () => Promise<void>;
  listPasskeys: () => Promise<AuthPasskey[]>;
  deletePasskey: (credentialId: string) => Promise<void>;
}

export const [AuthProvider, useAuthContext] = createSafeContext<AuthContextType>(
  'useAuthContext must be used within AuthProvider'
);
